import React, { useEffect, useState } from 'react';
import { companyAdminAPI } from '../../lib/walletApi';
import { Card, CardContent } from '../../components/ui/card';
import { CreditCard, Loader2 } from 'lucide-react';

export default function CompanyPayouts() {
  const [payouts, setPayouts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { companyAdminAPI.getPayouts().then(d => setPayouts(Array.isArray(d) ? d : [])).catch(() => {}).finally(() => setLoading(false)); }, []);
  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-pink-400" /></div>;
  return (
    <div className="space-y-6" data-testid="company-payouts">
      <div><h1 className="text-xl font-bold text-gray-900">Payouts</h1><p className="text-sm text-gray-500">{payouts.length} requests</p></div>
      <div className="space-y-2">
        {payouts.map(p => (
          <Card key={p.id} className="border-gray-200 shadow-sm"><CardContent className="p-3 flex items-center justify-between">
            <div className="flex items-center gap-3"><div className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center"><CreditCard className="w-4 h-4" /></div><div><p className="text-sm font-medium text-gray-900">NGN {Number(p.amount || 0).toLocaleString()}</p><p className="text-xs text-gray-400">{new Date(p.created_at).toLocaleDateString()}</p></div></div>
            <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${p.status === 'completed' ? 'bg-emerald-50 text-emerald-600' : p.status === 'pending' ? 'bg-amber-50 text-amber-600' : 'bg-gray-100 text-gray-500'}`}>{p.status}</span>
          </CardContent></Card>
        ))}
        {payouts.length === 0 && <Card className="border-gray-200"><CardContent className="p-8 text-center text-gray-400 text-sm">No payout requests</CardContent></Card>}
      </div>
    </div>
  );
}
